/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EnrollmentDocumentDropDownItemViewModel } from "../types/EnrollmentDocumentDropDownItemViewModel.ts";

export const enrollmentDocumentDropDownItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do documento de matrícula.")),
  name: z.string().describe("Nome do documento de matrícula.").nullish(),
  isRequired: z.optional(
    z.boolean().describe("Indica se o documento de matrícula é obrigatório."),
  ),
  acceptedFormats: z
    .string()
    .describe(
      "Formatos de arquivo aceitos para este documento (ex: PDF, JPG, PNG).",
    )
    .nullish(),
}) as unknown as ToZod<EnrollmentDocumentDropDownItemViewModel>;
